const getters = {
  destinations: (state) => state.destinations,
};

export default getters;
